module.exports = __webpack_public_path__ + "static/answers-sol-97189d1c34fc12bd374d3f6fc8ccbbb1.webp";